import { HttpHeaders, HttpParams, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { PBTOptInStep1 } from '../models/Pay by Text/PBTOptInStep1.model';
import { PBTOptInStep2 } from '../models/Pay by Text/PBTOptInStep2.model';
import { PBTOptOut } from '../models/Pay by Text/PBTOptOut.model';
import { PBTEditPhoneStep1 } from '../models/Pay by Text/PBTEditPhoneStep1.model';
import { PBTEditPhoneStep2 } from '../models/Pay by Text/PBTEditPhoneStep2.model';
import { PBTCreatePayment } from '../models/Pay by Text/PBTCreatePayment.model';
import { PBTCancelPayment } from '../models/Pay by Text/PBTCancelPayment.model';
import { RecurringCreditCardCancel } from '../models/Pay by Text/RecurringCreditCardCancel.model';
import { RecurringCreditCardBilling } from '../models/Pay by Text/RecurringCreditCardBilling.model';
import { RecurringCreditCardPayment } from '../models/Pay by Text/RecurringCreditCardPayment.model';
import { DirectDepositCreate } from '../models/Direct Deposit/DirectDeposit';

@Injectable({
  providedIn: 'root'
})
export class EpayExtendedServiceService {
  gateway = 'EPayGateway/EPay/api/v1/';

  httpOptions = {
    headers: new HttpHeaders(),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  resetHeader() {
    this.httpOptions.headers = new HttpHeaders().set(
      'Content-Type',
      'application/json'
    );
  }

  ////////////////////////////////////////////////////
  /////////// Electronic Billing ////////////////////
  //////////////////////////////////////////////////

  getEBPeriodicStatements(
    baseurl: string,
    secondaryId: string,
    tertiaryId: string
  ): Observable<any> {
    const apiCmd = 'getMostRecentPeriodicStatement';
    const gateway = 'EPayGateway/EPay/api/v1/OnlineStatements:';

    this.httpOptions.params = new HttpParams()
      .set('secondaryId', secondaryId)
      .set('tertiaryId', tertiaryId);

    return this.http.get<any>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getEBOptInStatus(
    baseurl: string
  ): Observable<any> {
    const apiCmd = 'getOptInStatus';
    const gateway = 'EPayGateway/EPay/api/v1/OnlineStatements:';

    return this.http.get<any>(baseurl + gateway + apiCmd).pipe(
      tap((data: any) => {
        sessionStorage.setItem('EBStatus', data)
      }),
      catchError(this.handleError)
    );
  }

  setEBOptIn(
    baseurl: string,
  ): Observable<any> {
    const apiCmd = 'optIn';
    const gateway = 'EPayGateway/EPay/api/v1/OnlineStatements:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, '')
      .pipe(catchError(this.handleError)); 
  }

  setEBOptOut(    
    baseurl: string,
  ): Observable<any> {
    const apiCmd = 'optOut';
    const gateway = 'EPayGateway/EPay/api/v1/OnlineStatements:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, '')
      .pipe(catchError(this.handleError)); 
  }

  getCouponBarcode (
    baseurl: string,
    fontSize: number,
  ) {

    const apiCmd = 'ElectronicBilling/Coupon';

    this.httpOptions.params = new HttpParams().set(
      'fontSize',
      50
    );

    // return this.http
    //   .get<any[]>(baseurl + this.gateway + apiCmd, this.httpOptions)
    //   .pipe(catchError(this.handleError));
    return this.http.get(baseurl + this.gateway + apiCmd, {responseType: 'text'}).pipe(
      tap((data: any) => {
        console.log('image data', data);
      }),
      catchError(this.handleError)
    );
  }

  getCouponSSN (
    baseurl: string,
  ) {

    const apiCmd = 'ElectronicBilling/Identifier';

    return this.http.get(baseurl + this.gateway + apiCmd, {responseType: 'text'}).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  ////////////////////////////////////////////////////
  ////////////////// Pay by Text ////////////////////
  //////////////////////////////////////////////////

  getPBTHistory (
    baseurl: string
  ): Observable<any[]> {
    const apiCmd = 'getHistory/';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams().set('months', 12);
    var months = 12;

    return this.http.get<any[]>(baseurl + gateway + apiCmd + months, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  // Use to get particular scheduled text
  getPBTPayment (
    baseurl: string,
    scheduledPaymentId: number
  ): Observable<any> {
    const apiCmd = 'getPayment/';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams()
      //.set('Client', 4)
      .set('scheduledPaymentId', scheduledPaymentId);

    return this.http.get<any>(baseurl + gateway + apiCmd + scheduledPaymentId.toString(), this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  // Use for current scheduled texts
  // use scheduledPaymentId of -1
  getPBTScheduledPayment (    
    baseurl: string,
    scheduledPaymentId: number
  ): Observable<any> {
    const apiCmd = 'scheduled/';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams()
      .set('scheduledPaymentId', scheduledPaymentId);

    return this.http.get<any>(baseurl + gateway + apiCmd + scheduledPaymentId.toString(), this.httpOptions).pipe(
      tap((data: any) => {
        console.log("** ", data)
      }),
      catchError(this.handleError)
    );
  }

  getPBTOptInStatus (
    baseurl: string
  ): Observable<any> {
    const apiCmd = 'getOptInStatus';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    return this.http
      .get<any>(
        baseurl + gateway + apiCmd
      )
      .pipe(
        tap((data: any) => {
          sessionStorage.setItem('T2PStatus', data)
        }),
        catchError(this.handleError)
      );
  }

  setPBTOptInStep1 (
    baseurl: string,
    step1Data: PBTOptInStep1,
  ): Observable<any> {
    const apiCmd = 'optInStep1';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, step1Data)
      .pipe(catchError(this.handleError)); 
  }

  setPBTOptInStep2 (
    baseurl: string,
    step2Data: PBTOptInStep2,
  ): Observable<any> {
    const apiCmd = 'optInStep2';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    return this.http
      .post<any>(baseurl + gateway + apiCmd, step2Data)
      .pipe(catchError(this.handleError)); 
  }

  setPBTOptOut (    
    baseurl: string
  ): Observable<any> {
      const apiCmd = 'optOut';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, '')
        .pipe(catchError(this.handleError)); 
  }

  setPBTPhoneEditStep1 (    
    baseurl: string,
    phoneEditStep1: PBTEditPhoneStep1,
  ): Observable<any> {
      const apiCmd = 'phoneEditStep1';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, phoneEditStep1)
        .pipe(catchError(this.handleError)); 
  }

  setPBTPhoneEditStep2 (    
    baseurl: string,
    phoneEditStep2: PBTEditPhoneStep2,
  ): Observable<any> {
      const apiCmd = 'phoneEditStep2';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, phoneEditStep2)
        .pipe(catchError(this.handleError)); 
  }

  getPBTCases (    
    baseurl: string,
    primaryId: string,
    secondaryId: string,
    tertiaryId: string,
    quaternaryId: string
  ): Observable<any[]> {
    const apiCmd = 'GetCases';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams()
    .set('primaryId', primaryId)
    .set('secondaryId', secondaryId)
    .set('tertiaryId', tertiaryId)
    .set('quaternaryId', quaternaryId);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getPBTOrders (    
    baseurl: string,
    secondaryId: string,
  ): Observable<any[]> {
    const apiCmd = 'getOrders';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams()
    .set('Client', 4)
    .set('secondaryId', secondaryId);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getPBTFrequencies (    
    baseurl: string,
  ): Observable<any[]> {
    const apiCmd = 'getFrequencies';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams()
    .set('Client', 4);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getPBTSchedules (    
    baseurl: string,
    scheduleFrequency: string
  ): Observable<any[]> {
    const apiCmd = 'getSchedules';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringText:';

    this.httpOptions.params = new HttpParams()
    .set('scheduleFrequency', scheduleFrequency)
    .set('Client', 4);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  createPBTPayment (    
    baseurl: string,
    pbtPayment: PBTCreatePayment,
  ): Observable<any> {
      const apiCmd = 'createPayment';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditText:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, pbtPayment)
        .pipe(catchError(this.handleError)); 
  }

  cancelPBTPayment (    
    baseurl: string,
    schedulePaymentId: any,
  ): Observable<any> {
      const apiCmd = 'cancelPayment';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditText:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, schedulePaymentId)
        .pipe(catchError(this.handleError)); 
  }

  getActiveInactiveLogins (
    baseurl: string
  ): Observable<any[]> {
    const apiCmd = 'getActiveandInactiveLogins';
    const gateway = 'EPayGateway/EPay/api/v1/UserExternals:';

    return this.http.get<any[]>(baseurl + gateway + apiCmd).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  ////////////////////////////////////////////////////
  ///////////// Recurring Credit Card ///////////////
  //////////////////////////////////////////////////

  getRecurringCCHistory (
    baseurl: string
  ): Observable<any[]> {
    const apiCmd = 'getHistory';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams().set('months', 6);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCCPayment (
    baseurl: string,
    scheduledPaymentId: number
  ): Observable<any> {
    const apiCmd = 'getPayment';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams()
      //.set('Client', 4)
      .set('scheduledPaymentId', scheduledPaymentId);

    return this.http.get<any>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCCScheduledPayments (    
    baseurl: string,
    scheduledPaymentId: number
  ): Observable<any> {
    const apiCmd = 'scheduled';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams()
      .set('scheduledPaymentId', scheduledPaymentId);

    return this.http.get<any>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
        console.log("** ", data)
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCreditCards (    
    baseurl: string,
  ): Observable<any> {
    const apiCmd = 'getCreditCards';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    return this.http.get<any>(baseurl + gateway + apiCmd).pipe(
      tap((data: any) => {
        console.log("** ", data)
      }),
      catchError(this.handleError)
    );
  }

  cancelRecurringCreditCard (    
    baseurl: string,
    cardID: any,
  ): Observable<any> {
      const apiCmd = 'cancelCreditCard';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, cardID)
        .pipe(catchError(this.handleError)); 
  }

  updateRecurringCreditCardBilling (    
    baseurl: string,
    creditCardBilling: RecurringCreditCardBilling,
  ): Observable<any> {
      const apiCmd = 'updateCreditCardBillingInfo';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, creditCardBilling)
        .pipe(catchError(this.handleError)); 
  }
  
  getRecurringCreditCardCases (    
    baseurl: string,
    primaryId: string,
    secondaryId: string,
    tertiaryId: string,
    quaternaryId: string
  ): Observable<any[]> {
    const apiCmd = 'getCases';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams()
    .set('primaryId', primaryId)
    .set('secondaryId', secondaryId)
    .set('tertiaryId', tertiaryId)
    .set('quaternaryId', quaternaryId);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCreditCardOrders (    
    baseurl: string,
    secondaryId: string,
  ): Observable<any[]> {
    const apiCmd = 'GetOrders';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams()
    .set('Client', 4)
    .set('secondaryId', secondaryId);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCreditCardFrequencies (    
    baseurl: string,
  ): Observable<any[]> {
    const apiCmd = 'GetFrequencies';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams()
    .set('Client', 4);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCreditCardSchedules (    
    baseurl: string,
    scheduleFrequency: string
  ): Observable<any[]> {
    const apiCmd = 'GetSchedules';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    this.httpOptions.params = new HttpParams()
    .set('scheduleFrequency', scheduleFrequency)
    .set('Client', 4);

    return this.http.get<any[]>(baseurl + gateway + apiCmd, this.httpOptions).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  createRecurringCreditCardPayment (    
    baseurl: string,
    recurringCCPayment: RecurringCreditCardPayment,
  ): Observable<any> {
      const apiCmd = 'CreatePayment';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, recurringCCPayment)
        .pipe(catchError(this.handleError)); 
  }

  cancelRecurringCreditCardPayment (    
    baseurl: string,
    schedulePaymentId: any,
  ): Observable<any> {
      const apiCmd = 'cancelPayment';
      const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';
  
      return this.http
        .post<any>(baseurl + gateway + apiCmd, schedulePaymentId)
        .pipe(catchError(this.handleError)); 
  }

  getRecurringCreditCardAccountRedirect (    
    baseurl: string,
  ): Observable<any[]> {
    const apiCmd = 'GetAccountRedirect';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    return this.http.get<any[]>(baseurl + gateway + apiCmd).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  getRecurringCreditCardRedirect (    
    baseurl: string,
  ): Observable<any[]> {
    const apiCmd = 'GetCreditCardRedirect';
    const gateway = 'EPayGateway/EPay/api/v1/PaymentRecurringCreditCard:';

    return this.http.get<any[]>(baseurl + gateway + apiCmd).pipe(
      tap((data: any) => {
      }),
      catchError(this.handleError)
    );
  }

  createDirectDeposit (    
    baseurl: string,
    directDepositCreate: DirectDepositCreate,
  ): Observable<any> {
      const apiCmd = 'createApplication';
      const gateway = 'EPayGateway/EPay/api/v1/DirectDeposit:';

      this.httpOptions.params = new HttpParams()
      .set("Client", 4);

      return this.http
        .post<any>(baseurl + gateway + apiCmd, directDepositCreate, this.httpOptions)
        .pipe(catchError(this.handleError)); 
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An Error Occurred: ${err.error.message}`;
    } else if (err.status === 404 || err.status === 409) {
      return throwError(() => err);
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
      console.log('Error Occurred: ' + errorMessage);
    }
    return throwError(() => err);
  }
}
